/* eslint-disable prettier/prettier */
import Vue from 'vue'
import { isEmpty } from 'lodash'

import DrBtn from '@/components/Buttons/DrBtn.vue'
// import OtpDialog from '@/components/OTP/OtpDialog';
import { t } from '@/store/modules/homeDrushim/constantsContent'

function install(Vue, options) {
  if (process.browser) {
    window.dataLayer = window.dataLayer || []
  }

  Vue.component('DrBtn', DrBtn)
  // Vue.component('OtpDialog', OtpDialog)

  Vue.filter('strippedContent', function (value) {
    if (!value) return ''
    return value.replace(/<\/?[^>]+>/gi, ' ')
  })

  Vue.mixin({
    components: {  },
    methods: {
      t: t,
      getString(collection, value) {
        if (!isEmpty(collection)) {
          const constants = collection.Keys.map(function (item) {
            return {
              Key: item.KeyValue.Key,
              Value: item.KeyValue.Value,
              Link: item.Link
            }
          })

          if (!isEmpty(constants)) {
            return constants.find(a => a.Key == value)
          }
        }

        return { Key: '', Value: '', Link: '' }
      }
    }
  })

  Vue.config.errorHandler = function (err) {
    console.error('Error in errorHandler', err)
  }
}

const DrushimVuePlugin = {
  install
}

Vue.use(DrushimVuePlugin)
